<template>
  <v-card v-if="resultMode" class="mt-4">
    <v-card-text
      class="d-flex align-center justify-space-between bg-grey-lighten-5">
      <div class="d-flex align-center ga-3">
        <v-sheet
          class="d-flex align-center justify-center flex-shrink-0"
          color="light-blue"
          height="40"
          rounded="lg"
          width="40">
          <v-icon color="secondary" icon="mdi-magnify" size="24"></v-icon>
        </v-sheet>
        <div>
          <div class="font-size-14 font-weight-bold">Результати пошуку</div>
          <div class="font-size-12 text-disabled">
            Знайдено {{ resultsCount }} документів · {{ resultTitle }}
          </div>
        </div>
      </div>

      <v-btn
        border
        color="white"
        prepend-icon="mdi-close"
        @click="resetResults">
        <span class="font-weight-light">Скинути</span>
      </v-btn>
    </v-card-text>

    <b-server-table
      :key="searchRequestKey"
      :headers="headers"
      :request-func="getSearchResults">
      <template #item.documentNumber="{ item }">
        <router-link
          class="link"
          target="_blank"
          :to="{ name: 'document-single', params: { uuid: item.uuid } }">
          <div class="d-flex align-center gap-1">
            <span>{{ getCellValue(item.documentNumber, 'Без номера') }}</span>
            <v-icon icon="mdi-open-in-new" size="x-small"></v-icon>
          </div>
        </router-link>
      </template>
      <template #item.title="{ item }">
        <div class="search-result-title" :title="getCellValue(item.title)">
          {{ getCellValue(item.title) }}
        </div>
      </template>
      <template #item.registrationJournal="{ item }">
        {{ getCellValue(item.registrationJournal) }}
      </template>
      <template #item.registrationDate="{ item }">
        {{ getCellValue(item.registrationDate) }}
      </template>
      <template #item.department="{ item }">
        {{ getCellValue(item.department) }}
      </template>
      <template #item.author="{ item }">
        {{ getCellValue(item.author) }}
      </template>
      <template #item.createdAt="{ item }">
        {{ getCellValue(item.createdAt) }}
      </template>
      <template #item.status="{ item }">
        <v-chip
          :color="getStatusColor(item.status)"
          variant="tonal">
          <span class="font-weight-bold">{{
            getStatusTitle(item.status)
          }}</span>
        </v-chip>
      </template>
    </b-server-table>
  </v-card>
</template>

<script lang="ts" setup>
import { useSearch } from '@/pages/search/search'
import { searchResultHeaders } from '@/utils/tableHeaders'
import type { SearchResultStatus } from '@/utils/types/search'
import { BServerTable } from 'best-modules/components'

defineOptions({
  name: 'SearchResults',
})

const {
  getSearchResults,
  resultMode,
  resultTitle,
  resultsCount,
  resetResults,
  searchRequestKey,
} = useSearch()
const headers = searchResultHeaders

const getCellValue = (value?: null | string, fallback = '—') => {
  return value?.trim() || fallback
}

const getStatusTitle = (status: SearchResultStatus) => {
  return status === 'registered' ? 'Зареєстрований' : 'На реєстрації'
}

const getStatusColor = (status: SearchResultStatus) => {
  return status === 'registered' ? 'success' : 'error'
}
</script>
